const mapEl = document.getElementById('seminar-facts-google-map');

if (mapEl) {
    let geocoder = new google.maps.Geocoder();
    let mapOptions = {
        zoom: 17,
    };
    const address = mapEl.getAttribute('data-address');
    let map = new google.maps.Map(mapEl, mapOptions);

    if (address) {
        geocoder.geocode({ address: address }, function (results, status) {
            if (status == 'OK') {
                map.setCenter(results[0].geometry.location);
                let marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location,
                });
            } else {
                mapEl.display = 'none';
                console.err('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
}
